export var DayRange;
(function (DayRange) {
    DayRange[DayRange["CalendarWeek"] = 0] = "CalendarWeek";
    DayRange[DayRange["JustToday"] = 1] = "JustToday";
    DayRange[DayRange["YesterdayPlusSixDays"] = 2] = "YesterdayPlusSixDays";
    DayRange[DayRange["YesterdayPlusTwoDays"] = 3] = "YesterdayPlusTwoDays";
    DayRange[DayRange["WorkingWeek"] = 4] = "WorkingWeek";
})(DayRange || (DayRange = {}));
export var TimeFormat;
(function (TimeFormat) {
    TimeFormat[TimeFormat["TwentyFourHour"] = 0] = "TwentyFourHour";
    TimeFormat[TimeFormat["TwelveHour"] = 1] = "TwelveHour";
})(TimeFormat || (TimeFormat = {}));
//# sourceMappingURL=index.js.map